// extracted by mini-css-extract-plugin
export default {"tags":"PatientInfo__tags--HGqKq","tag":"PatientInfo__tag--lddz-"};